export const InjectionI18nTitle = Symbol('i18nTitle');
